import messages from './messages'

export { useFormatMessage } from './hooks/useFormatMessage'
export { useLocale } from './hooks/useLocale'

export const DEFAULT_LOCALE = 'pt-BR'

export default messages
